import { BREADCRUMBS_ACTIONS } from '../constants/action.constants';

export function set(breadcrumbs) {
  return { type: BREADCRUMBS_ACTIONS.SET, breadcrumbs };
}

export function reset() {
  return { type: BREADCRUMBS_ACTIONS.RESET };
}
